import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { VehicleModelService } from '../../../core/services/vehicle/vehicle-model/vehicle-model.service'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'

@Component({
  selector: 'vehicle-model-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
  ],
  templateUrl: './vehicle-model-edit.component.html',
  styleUrl: './vehicle-model-edit.component.scss',
  providers: [VehicleModelService, VehicleTypeService],
  standalone: true,
})
export class VehicleModelEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private vehicleModelService: VehicleModelService,
    private vehicleTpeService: VehicleTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<VehicleModelEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data
  }

  @Output() responseEdit = new EventEmitter()

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  listType: any[] = []

  ngOnInit(): void {
    this.createForm()
    // this.listTypeVehicle()
  }

  // listTypeVehicle() {
  //   this.vehicleTpeService.listVehicleType().subscribe({
  //     next: (response: ResponseRequestModel) => {
  //       this.listType = response.data
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => {},
  //   })
  // }

  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.vehicleModelService.editVehicleModel(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.itemEdit.id,
      nome: this.form.controls['name'].value,
      contato: this.form.controls['contact'].value,
      email: this.form.controls['email'].value,
    }
  }

  createForm(): void {
    console.log('item', this.itemEdit)
    this.form = this.formBuilder.group({
      code: [this.itemEdit.id, [Validators.required]],
      name: [this.itemEdit.nome, [Validators.required]],
      contact: [this.itemEdit.contato, [Validators.required]],
      email: [this.itemEdit.email, [Validators.required]],
    })
    this.form.get('code')?.disable()
  }
}
